import { useEffect, useState } from "react";
import { useVendorsStore } from "../../../store/vendors.store";
import { useAuthStore } from "../../../store/auth.store";
import { useVendorWarehouseSales } from "../../../hook/partner/vendorWarehouseSales.partner.hook";
import { PartnerApi } from "../../../api/partner.api";
import number_format from "../../../utils/number_format";
import OpportunityItemsModal from "../../../components/modals/opportunity/OpportunityItemsModal";
import VendorDetailWarehouseSaleItemModal from "../../../components/modals/vendor/VendorDetailWarehouseSaleItemModal";
import { useTranslation } from "../../../hooks/useTranslation";

function VendorDetailWarehouseSales(props) {
  const { t } = useTranslation();
  const vendor = props.vendor;

  const vendorWarehouseSalesMutation = useVendorWarehouseSales();

  const token = useAuthStore((state) => state.token);
  const warehouseSales = useVendorsStore((state) => state.warehouseSales);

  const [cart, setCart] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);

  const findMinimalPrice = (items) => {
    let minimal = 999999999;
    for (let i = 0; i < items.length; i++) {
      minimal = Math.min(minimal, items[i].fixedPrice);
    }
    return minimal;
  };

  useEffect(() => {
    if (token) {
      vendorWarehouseSalesMutation.mutate({ token, id: vendor.vendor_id });
    }
  }, [token, vendor]);

  if (vendorWarehouseSalesMutation.isLoading) {
    return <p>{t("common.loading")}</p>;
  }

  if (!warehouseSales) {
    return <></>;
  }

  if (warehouseSales?.length === 0) {
    return <>{t("common.notFound")}</>;
  }
  console.log(warehouseSales);

  return (
    <>
      {/*
            <h1 className={"mt-16 mb-4"}>Výprodej</h1>
*/}
      <div className="row">
        {warehouseSales?.length > 0 ? (
          warehouseSales?.map((products, products_key) => (
            <div className="col-12 col-md-4 mb-5" key={products_key}>
              <VendorDetailWarehouseSaleItemModal
                  title={products.product_type + " " +products.name}
                  show={showModalDetail === "waresale-" + products.product_id}
                  handleClose={() => setShowModalDetail(false)}
                  setCart={setCart}
                  products={products}
                  setShowModal={setShowModal}
              />

              <OpportunityItemsModal
                show={showModal === products.product_id}
                handleClose={() => setShowModal(false)}
                items={cart}
              />

              <div className="card h-100">
                <div className="card-body">
                  <span className="badge badge-success">
                    {Math.round(
                      (1 -
                        findMinimalPrice(products.warehouse_sale) /
                          products.warehouse_sale[0]
                            .catalog_price_in_sale_currency) *
                        100
                    )}
                    % {t("vendors.discount")}
                  </span>
                  <img
                    className="mw-100 mb-4"
                    style={{
                      aspectRatio: "1 / 1",
                      objectFit: "contain",
                    }}
                    src={
                      PartnerApi.url +
                      "/product/" +
                      products.product_id +
                      "/image.jpg"
                    }
                    alt={products.sku}
                  />

                  <h2 className="mb-4">{products.sku}</h2>
                  <p>{t("vendors.inStock")}: {products.warehouse_sale.length} {t("vendors.pieces")}</p>
                  <h3 className="mb-4">
                    {t("vendors.from")}{" "}
                    {number_format(
                      findMinimalPrice(products.warehouse_sale),
                      2,
                      ",",
                      "."
                    )}{" "}
                    {products.warehouse_sale[0].currency}
                  </h3>
                  <button
                    className="btn btn-primary"
                    onClick={()=>setShowModalDetail("waresale-" + products.product_id)}
                  >
                    {t("common.detail")}
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>{t("vendors.noProductFound")}</p>
        )}
      </div>
    </>
  );
}

export default VendorDetailWarehouseSales;
